import React from 'react';
import { Container, If } from '../../Components';
import {
  getTischOffensivesForId,
  getProductsForTischOffensiveId,
} from '../../selectors';
import { Products } from './Products';
import { ProductTitle } from './ProductTitle';

export const TischOffensiveProducts = ({ context, tischOffensiveId }) => {
  const tischOffensive = getTischOffensivesForId({
    context,
    id: tischOffensiveId,
  });
  const ti = getProductsForTischOffensiveId({
    context,
    tischOffensiveId,
  });

  const products = ti.products;
  const colours = ti.colours;

  return (
    <If condition={tischOffensive}>
      {() => (
        <>
          <Container>
            <ProductTitle description={tischOffensive.description} />
          </Container>
          <Products
            tischOffensiveId={tischOffensiveId}
            products={products}
            colours={colours}
          />
        </>
      )}
    </If>
  );
};
